// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"487":"storeMenu","757":"game","842":"map"}[chunkId] + "." + {"487":"fdf10df3","757":"a1fa4541","842":"05e6b705"}[chunkId] + ".css";
};